import { render } from "./UserLikedItemListPage.vue?vue&type=template&id=3bf9674a&scoped=true"
import script from "./UserLikedItemListPage.vue?vue&type=script&lang=ts"
export * from "./UserLikedItemListPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3bf9674a"

export default script